import React from 'react'
import _ from 'lodash'
import { Helmet } from 'react-helmet'
import BlockTitle from '~/components/BlockTitle'

class RawHtml extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      scriptTags: [],
      rawHtml: null
    }
  }

  componentDidMount() {
    this.splitScriptTagsFromHtml()
  }

  splitScriptTagsFromHtml() {
    if (!this.props.data) 
      return

    const html = document.createElement("div")
    html.innerHTML = this.props.data.rawText

    const copiedScriptTags = this.copyScriptsInHtml(html)
    const noScriptHtml = this.removeScriptTagsFromHtml(html)

    this.setState({ 
      scriptTags: copiedScriptTags,
      rawHtml: noScriptHtml.innerHTML.toString()
    })
  }

  // Copy each script tag and re-append to the dom so that they will execute
  //   (React doesn't execute code inside of script tags inserted at runtime)
  copyScriptsInHtml(htmlNode) {
    const scriptTags = htmlNode.getElementsByTagName("script")

    return _.map(scriptTags, tag => {
      if (tag) {
        let newTag = document.createElement("script")
        tag.src && (newTag.src = tag.src)
        tag.textContent && (newTag.textContent = tag.textContent)
        return newTag
      }
    })
  }

  removeScriptTagsFromHtml(html) {
    const noScriptHtml = html
    const scriptTags = html.getElementsByTagName("script")
    _.forEach(scriptTags, tag => {
      if (tag)
        tag.parentElement.removeChild(tag)
    })
    return noScriptHtml
  }

  componentWillUnmount() {
    _.forEach(this.state.scriptTags, tag => tag.remove())
  }

  loadScriptTags() {
    return _.map(this.state.scriptTags, (tag, idx) => {
      // react-helmet doesn't omit attributes that have a falsey value
      return tag.src 
        ? <script key={ idx } src={ tag.src }></script>
        : <script key={ idx }>{ tag.textContent }</script>
    })
  }

  render() {
    const title = _.get(this.props, 'data.title', '')

    return (
      <div className="raw-html">
        { title && 
          <BlockTitle>{ title }</BlockTitle>
        }
        { this.state.scriptTags &&
          <Helmet>
            { this.loadScriptTags() }    
          </Helmet>
        }
        {this.state.rawHtml && (
          <div
            className="raw-html__content"
            dangerouslySetInnerHTML={{ __html: this.state.rawHtml }}
          />
        )}
      </div>
    )
  }
}

export default RawHtml